import React, { useMemo } from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';
import styles from './Modal.less';

import PropTypes from 'prop-types';
import invariant from 'tiny-invariant';
import MaterialIcon from './MaterialIcon';

export function Modal({
  show,
  title,
  children,
  footer,
  disableHide = false,
  ...props
}) {
  const ContentComponent = props.onSubmit ? 'form' : 'div';
  const onHide = disableHide ? undefined : props.onHide;
  const onSubmit = useMemo(() => {
    if (props.onSubmit) {
      return (e) => {
        e.preventDefault();
        props.onSubmit();
      };
    }
  }, [props.onSubmit]);
  return (
    <BootstrapModal
      show={show}
      dialogAs={ModalContent}
      onHide={onHide}
      backdropClassName={styles.backdrop}
    >
      <ContentComponent className={styles.content} onSubmit={onSubmit}>
        {!disableHide && (
          <button
            className={styles.closeButton}
            onClick={(e) => {
              e.preventDefault();
              onHide();
            }}
          >
            <MaterialIcon icon="close" classOverride={styles.closeIcon} />
          </button>
        )}
        <div className={styles.title}>{title}</div>
        <div className={styles.body}>{children}</div>
        {footer && <div className={styles.footer}>{footer}</div>}
      </ContentComponent>
    </BootstrapModal>
  );
}

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onHide: PropTypes.func.isRequired,
  footer: PropTypes.element,
  onSubmit: PropTypes.func,
  disableHide: PropTypes.bool,
};

const ModalContent = React.forwardRef(
  ({ children, className, contentClassName, ...props }, ref) => {
    invariant(!contentClassName);
    return (
      <div ref={ref} className={styles.container} {...props}>
        {children}
      </div>
    );
  },
);
